module.exports = __webpack_public_path__ + "img/bs.ebf9e550.svg";